import { useState } from 'react';

const STATUS_META = {
  new:       { label: 'New',       pill: '🆕', color: '#0C447C' },
  hot:       { label: 'Hot',       pill: '🔥', color: '#A32D2D' },
  warm:      { label: 'Warm',      pill: '☀️', color: '#633806' },
  cold:      { label: 'Cold',      pill: '❄️', color: '#27500A' },
  converted: { label: 'Converted', pill: '🏆', color: '#085041' },
  lost:      { label: 'Lost',      pill: '⚪', color: '#5F5E5A' },
  followup:  { label: 'Followup',  pill: '⏰', color: '#854F0B' },
};

const timeAgo = (ts) => {
  if (!ts) return '—';
  const diff = Date.now() - new Date(ts).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

const MOCK_TIMELINE = [
  { id: 1, type: 'lead_created', text: 'Lead created via Get Quote', ts: Date.now() - 86400000 * 3 },
  { id: 2, type: 'status_change', text: 'Status changed: New → Hot', ts: Date.now() - 86400000 * 2 },
  { id: 3, type: 'comment', text: 'Called customer, interested in cotton saree. Follow up tomorrow.', ts: Date.now() - 86400000 },
  { id: 4, type: 'followup_set', text: 'Follow-up date set: Tomorrow', ts: Date.now() - 3600000 },
];

export function LeadTimeline({ lead, onClose, onQuickAction }) {
  const [activeTab, setActiveTab] = useState('timeline');
  const waUrl = `https://wa.me/${(lead.phone || '').replace(/[^0-9]/g, '')}`;
  const status = STATUS_META[lead.status] || STATUS_META.new;

  const tabStyle = (active) => ({
    padding: '10px 16px', fontSize: 12, fontWeight: 700, cursor: 'pointer', border: 'none',
    background: 'none', borderBottom: active ? '2px solid #25d366' : '2px solid transparent',
    color: active ? '#25d366' : '#999', fontFamily: 'inherit',
  });

  const iconOf = (type) => {
    if (type === 'lead_created') return '🆕';
    if (type === 'status_change') return '🔄';
    if (type === 'comment') return '💬';
    if (type === 'followup_set') return '📅';
    if (type === 'whatsapp') return '📱';
    return '📌';
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1200, display: 'flex', justifyContent: 'flex-end' }} onClick={onClose}>
      <div style={{ width: 420, maxWidth: '95vw', height: '100%', background: '#fff', boxShadow: '-4px 0 24px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg,#075e54,#128c7e)', padding: '20px 20px 16px', color: '#fff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 800 }}>{lead.name || 'Unknown'}</div>
              <div style={{ fontSize: 12, opacity: 0.8, marginTop: 3 }}>📱 {lead.phone}</div>
              {lead.product_tag && <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2 }}>📦 {lead.product_tag}</div>}
            </div>
            <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8, color: '#fff', fontSize: 18, cursor: 'pointer', padding: '4px 10px' }}>✕</button>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
            <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>
              {status.pill} {status.label}
            </span>
            {lead.agent_name && <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 10px', borderRadius: 20, fontSize: 11 }}>👤 {lead.agent_name}</span>}
            {lead.follow_up_date && <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 10px', borderRadius: 20, fontSize: 11 }}>📅 {lead.follow_up_date.slice(0,10)}</span>}
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button onClick={() => window.open(waUrl, '_blank')} style={{ flex: 1, padding: '8px 0', background: '#25d366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>💬 WhatsApp</button>
            <button onClick={() => onQuickAction(lead)} style={{ flex: 1, padding: '8px 0', background: 'rgba(255,255,255,0.2)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>⚡ Quick Action</button>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
          <button style={tabStyle(activeTab === 'timeline')} onClick={() => setActiveTab('timeline')}>📋 Timeline</button>
          <button style={tabStyle(activeTab === 'details')} onClick={() => setActiveTab('details')}>📝 Details</button>
          <button style={tabStyle(activeTab === 'whatsapp')} onClick={() => setActiveTab('whatsapp')}>💬 Chat</button>
        </div>

        {/* Timeline tab */}
        {activeTab === 'timeline' && (
          <div style={{ padding: 20, flex: 1 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 14, textTransform: 'uppercase', letterSpacing: 0.5 }}>Activity Timeline</div>
            {MOCK_TIMELINE.map((item, i) => (
              <div key={item.id} style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f0faf5', border: '2px solid #25d366', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>{iconOf(item.type)}</div>
                  {i < MOCK_TIMELINE.length - 1 && <div style={{ width: 2, flex: 1, background: '#f0f0f0', marginTop: 4 }} />}
                </div>
                <div style={{ paddingBottom: 16 }}>
                  <div style={{ fontSize: 13, color: '#333', lineHeight: 1.4 }}>{item.text}</div>
                  <div style={{ fontSize: 11, color: '#aaa', marginTop: 3 }}>{timeAgo(item.ts)}</div>
                </div>
              </div>
            ))}
            <div style={{ fontSize: 11, color: '#bbb', textAlign: 'center', marginTop: 8, fontStyle: 'italic' }}>
              Backend connected aana real activity varum
            </div>
          </div>
        )}

        {/* Details tab */}
        {activeTab === 'details' && (
          <div style={{ padding: 20 }}>
            {[
              ['Lead ID', '#' + lead.id],
              ['Name', lead.name || '—'],
              ['Phone', lead.phone || '—'],
              ['Source', lead.source || '—'],
              ['Product', lead.product_tag || '— Manual'],
              ['Assigned Agent', lead.agent_name || '— Unassigned'],
              ['Status', `${status.pill} ${status.label}`],
              ['Follow-up Date', lead.follow_up_date ? lead.follow_up_date.slice(0,10) : '— Not set'],
              ['Created', lead.created_at ? new Date(lead.created_at).toLocaleString() : '—'],
              ['Notes', lead.notes || '— No notes'],
            ].map(([label, value]) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f8f8f8' }}>
                <span style={{ fontSize: 12, color: '#aaa', fontWeight: 600 }}>{label}</span>
                <span style={{ fontSize: 12, color: '#333', fontWeight: 500, maxWidth: 220, textAlign: 'right' }}>{value}</span>
              </div>
            ))}
          </div>
        )}

        {/* Chat tab */}
        {activeTab === 'whatsapp' && (
          <div style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
            <div style={{ fontSize: 40 }}>💬</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#333' }}>WhatsApp Chat</div>
            <div style={{ fontSize: 12, color: '#aaa', textAlign: 'center' }}>Backend integration pannina, customer-oda WhatsApp messages inga theriyum</div>
            <button onClick={() => window.open(waUrl, '_blank')} style={{ padding: '10px 24px', background: '#25d366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              Open in WhatsApp Web ↗
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
